module.exports = __webpack_public_path__ + "img/app-store.9dc24dcc.png";